export default "__VITE_ASSET__1ddc485d__"